import service from '@/utils/request'; // GetBairunSvcBalanceOptLogList 分页获取储值卡操作记录
// @Tags Svc
// @Summary 分页获取储值卡操作记录
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.BairunSvcBalanceOptLogSearch true "分页获取储值卡操作记录"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /stationOpLog/getSvcBalanceOptLogList [get]

export var getBairunSvcBalanceOptLogList = function getBairunSvcBalanceOptLogList(params) {
  return service({
    url: '/stationOpLog/getSvcBalanceOptLogList',
    method: 'get',
    params: params
  });
}; // downloadBairunSvcBalanceOptLog 下载
// @Tags Svc
// @Summary 下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /stationOpLog/download [post]

export var downloadBairunSvcBalanceOptLog = function downloadBairunSvcBalanceOptLog(data) {
  return service({
    url: '/stationOpLog/download',
    method: 'post',
    data: data
  });
};